import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import {
  ContenutoFile,
  ContenutoImmagine,
} from '../../core/models/contenuto-dinamico.models';

/**
 * Estrae il valore semplice di un campo di tipo testo/html/link. L'html
 * resta comunque sanificato da Angular quando legato a `[innerHTML]`.
 */
@Pipe({ name: 'contenutoValore', standalone: true })
export class ContenutoValorePipe implements PipeTransform {
  transform(campo: { valore: string } | null | undefined, fallback = ''): string {
    return campo?.valore ?? fallback;
  }
}

/**
 * Converte un campo di tipo immagine/file (base64 + mimeType) in un URL
 * `blob:` utilizzabile in `[src]`/`[href]`. Si usa un Blob (stesso pattern di
 * `downloadEdizione` in home.component.ts) invece di un `data:` URI grezzo:
 * i browser sono molto meno affidabili nel navigare/aprire in una nuova
 * scheda un `data:` URI di file di dimensioni reali (un PDF di poche
 * centinaia di KB può restare bianco o non aprirsi), mentre un `blob:` URL
 * funziona in modo consistente. Il contenuto arriva da BO (operatore
 * autenticato), non da input utente: bypassare la sanificazione dell'URL è
 * quindi accettabile.
 */
@Pipe({ name: 'contenutoRisorsa', standalone: true })
export class ContenutoRisorsaPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(campo: ContenutoImmagine | ContenutoFile | null | undefined): SafeUrl {
    // Placeholder in attesa che BO carichi il file/l'immagine: non naviga da nessuna parte.
    if (!campo?.valore) return this.sanitizer.bypassSecurityTrustUrl('#');

    const byteCharacters = atob(campo.valore);
    const byteArray = new Uint8Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    const blob = new Blob([byteArray], { type: campo.mimeType || 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }
}
